import { paramPath } from '../constants/parameterNames';
import { handleHelperResult } from '../helpers/apiResultHandling';
import { handleError } from '../helpers/errorHandling';
import { getParamValue } from '../helpers/parameter.accessors';

const description = 'Delete a local network file.';

const requiredParameters = {
    [paramPath]: {
        description: 'Path of the file to delete',
    },
};

const executeAsync = async ({ api, parameters }) => {
    const path = getParamValue(parameters, paramPath);

    return api
        .deleteNetworkFileAsync(path)
        .then(handleHelperResult)
        .catch(handleError);
};

const DeleteFile = {
    description,
    executeAsync,
    requiredParameters,
};

export default DeleteFile;
